import { Box, Typography, useTheme, Tooltip } from "@mui/material";
import clsx from "clsx";
import RenderSortIcons from "../utils/sortIcons";
import { FaArrowDown } from "react-icons/fa6";
import PropTypes from "prop-types";

const YieldHeadColumn = ({ sortBy, sortOrder, column, classes }) => {
  return (
    <Box className={classes.yieldHeaderWrapper}>
      <Typography
        className={clsx(classes.cursorptr, classes.themeColor)}
        variant="subtitle2"
        fontWeight={500}
      >
        {column.title}
      </Typography>
      {sortBy === column.key ? (
        RenderSortIcons(sortOrder, classes)
      ) : (
        <Tooltip title="Sort" arrow>
          <Box
            component={"span"}
            className={classes.placeholderArrowIcon}
            data-testid="initialSortArrow"
          >
            <FaArrowDown />
          </Box>
        </Tooltip>
      )}
    </Box>
  );
};

const YieldHeaders = ({
  showHideList,
  classes,
  toggleSortOrder,
  sortOrder,
  sortBy,
  selectedTaka,
}) => {
  // Show columns for Taka 4.1 a and Taka 4.1 c
  const showSpecialCols =
    selectedTaka === "Taka 4.1 a" || selectedTaka === "Taka 4.1 c";
  const taka41aParts = ["NA1/NA6", "SA1/SA6"];
  const taka41cParts = ["NC1", "SC1"];
  const selectedTakaPartVariable = selectedTaka === "Taka 4.1 a" ? "A" : "C";

  const getSuffix = (index) => {
    if (!showSpecialCols) return "";
    if (selectedTaka === "Taka 4.1 a" && taka41aParts[index]) {
      return `- ${taka41aParts[index]}`;
    }
    if (selectedTaka === "Taka 4.1 c" && taka41cParts[index]) {
      return `- ${taka41cParts[index]}`;
    }
    return "";
  };
  const isDarkMode = useTheme().palette.mode === "dark";
  const yieldHeaders = [
    {
      key: "BumpYield",
      title: "Bump",
      className: classes.yieldColumnHeader,
      show: showHideList.yield,
      render: (column) => (
        <YieldHeadColumn
          sortBy={sortBy}
          sortOrder={sortOrder}
          column={column}
          classes={classes}
        />
      ),
    },

    {
      key: "ProbeYield",
      title: "Probe",
      className: classes.yieldColumnHeader,
      show: showHideList.yield,
      render: (column) => (
        <YieldHeadColumn
          sortBy={sortBy}
          sortOrder={sortOrder}
          column={column}
          classes={classes}
        />
      ),
    },

    {
      key: "AssemblyYield",
      title: `Assembly ${
        showSpecialCols ? `- N${selectedTakaPartVariable}0` : ""
      }`,
      className: classes.yieldColumnHeader,
      show: showHideList.yield,
      render: (column) => (
        <YieldHeadColumn
          sortBy={sortBy}
          sortOrder={sortOrder}
          column={column}
          classes={classes}
        />
      ),
    },

    {
      key: "AssemblyYield_S",
      title: `Assembly - S${selectedTakaPartVariable}0`,
      className: classes.yieldColumnHeader,
      show: showHideList.yield && showSpecialCols,
      render: (column) => (
        <YieldHeadColumn
          sortBy={sortBy}
          sortOrder={sortOrder}
          column={column}
          classes={classes}
        />
      ),
    },

    {
      key: showSpecialCols ? "TestYield_N1" : "TestYield",
      title: `Test ${getSuffix(0)}`,
      className: classes.yieldColumnHeader,
      show: showHideList.yield,
      render: (column) => (
        <YieldHeadColumn
          sortBy={sortBy}
          sortOrder={sortOrder}
          column={column}
          classes={classes}
        />
      ),
    },

    {
      key: "TestYield_S1",
      title: `Test ${getSuffix(1)}`,
      className: classes.yieldColumnHeader,
      show: showHideList.yield && showSpecialCols,
      render: (column) => (
        <YieldHeadColumn
          sortBy={sortBy}
          sortOrder={sortOrder}
          column={column}
          classes={classes}
        />
      ),
    },
  ];
  return (
    <>
      {yieldHeaders.map(
        (column, index) =>
          column.show && (
            <Box
              data-testid={column.key}
              className={column.className}
              onClick={() => toggleSortOrder(column.key)}
              key={column.key}
              sx={{
                borderLeft:
                  index === 0 &&
                  `3px solid ${isDarkMode ? "#FFFFFF" : "#5b5d6e"}`,
                borderRight: `1px solid ${isDarkMode ? "#FFFFFF" : "#5b5d6e"}`,
              }}
            >
              {column.render(column)}
            </Box>
          )
      )}
    </>
  );
};

YieldHeaders.propTypes = {
  showHideList: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  toggleSortOrder: PropTypes.func.isRequired,
  sortOrder: PropTypes.string.isRequired,
  sortBy: PropTypes.string.isRequired,
  selectedTaka: PropTypes.string.isRequired,
};

YieldHeadColumn.propTypes = {
  sortBy: PropTypes.string.isRequired,
  sortOrder: PropTypes.string.isRequired,
  column: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default YieldHeaders;
